import { TEXTS } from './texts';

export const DEFAULT_UPLOAD_BUTTON_TEXT = TEXTS.DEFAULT_UPLOAD_BUTTON_TEXT;

export const DEFAULT_FILE_MIN_SIZE = 1024; // 1 Kb
export const DEFAULT_FILE_SIZE = 1024; // 1 Kb
export const DEFAULT_FILE_MAX_SIZE = 5 * 1024 * 1024; // 5 Mb
